import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-square",
  "use": "icon-square-usage",
  "viewBox": "0 0 200.0 200.0",
  "content": "<symbol viewBox=\"0 0 200.0 200.0\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-square\"><defs><clipPath id=\"icon-square_i0\"><path d=\"M175,0 C188.75,0 200,11.25 200,25 L200,175 C200,188.75 188.75,200 175,200 L25,200 C11.25,200 0,188.75 0,175 L0,25 C0,11.25 11.25,0 25,0 Z\" /></clipPath></defs><g clip-path=\"url(#icon-square_i0)\"><polygon points=\"0,0 200,0 200,200 0,200 0,0\" stroke=\"none\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol